import './App.css';


import Main from './Views/Main/Main';


function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
